
import {getListMessanger} from '../api/getListMessanger';
import {setGetListMessangerAction} from '../action';

const setGetListMessanger = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListMessanger(params);
            if (data.status === 'success') {
                dispatch(setGetListMessangerAction(data.data));           
            }
    
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListMessanger
}